import { useEffect, useState } from "react";
import api from "../lib/api";
import { CheckCircle2, XCircle, ShieldX } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const ICON = {
  success: { icon: CheckCircle2, cls: "text-primary" },
  error: { icon: XCircle, cls: "text-destructive" },
  rejected: { icon: ShieldX, cls: "text-destructive" },
};

function CallRow({ c }) {
  const m = ICON[c.result] || ICON.error;
  const Icon = m.icon;
  return (
    <div className="flex items-start gap-3 py-2.5" data-testid={`usage-row-${c.id}`}>
      <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${m.cls}`} />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <span className="font-mono capitalize">{c.action}</span>
          <span className={`rounded px-1.5 py-0.5 text-[10px] font-mono uppercase ${m.cls} bg-muted`}>{c.result} · {c.status_code}</span>
        </div>
        {c.detail && <div className="truncate text-xs text-muted-foreground">{c.detail}</div>}
        <div className="text-[11px] text-muted-foreground">{new Date(c.created_at).toLocaleString()}{c.ip && ` · ${c.ip}`}</div>
      </div>
    </div>
  );
}

export function KeyUsageDialog({ apiKey, onClose }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!apiKey) return;
    setData(null);
    api.get(`/api-keys/${apiKey.id}/usage`).then((r) => setData(r.data)).catch(() => setData({ calls: [], total: 0, failures: 0 }));
  }, [apiKey]);

  return (
    <Dialog open={!!apiKey} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="apikey-usage-dialog">
        <DialogHeader>
          <DialogTitle>Recent calls · {apiKey?.name}</DialogTitle>
          <DialogDescription>
            {data ? `${data.total} calls total, ${data.failures} failed or rejected. Showing the latest ${data.calls.length}.` : "Loading…"}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[420px] divide-y divide-border overflow-y-auto" data-testid="apikey-usage-list">
          {data && data.calls.length === 0 && <p className="py-8 text-center text-sm text-muted-foreground">This key hasn't been used yet.</p>}
          {data?.calls.map((c) => <CallRow key={c.id} c={c} />)}
        </div>
      </DialogContent>
    </Dialog>
  );
}
